<template>
    <div>
        <a-result v-if="noFound" status="warning" title="404" :sub-title="comment">
            <template #extra>
                <a href="/"><a-button type="primary">返回首页</a-button></a>
            </template>
        </a-result>
        <slot v-else></slot>
    </div>
</template>

<script>
export default {
    props: [ 'comment', 'noFound' ]
}
</script>

<style scoped>
.ant-result >>> .ant-result-title {
    font-size: 48px;
}
.ant-result >>> .ant-result-subtitle {
    font-size: 18px;
}
</style>